import { metaData } from '@cornerstonejs/metadata';
export const { addProvider, removeProvider, removeAllProviders, getMetaData, getTyped, get, getNormalized, toUpperCamelTag, toLowerCamelTag, } = metaData;
